import { render, staticRenderFns } from "./SalBaseDlg.vue?vue&type=template&id=9cd47928&scoped=true"
import script from "./SalBaseDlg.vue?vue&type=script&lang=js"
export * from "./SalBaseDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd47928",
  null
  
)

export default component.exports